<div class="start-live-modal">
  <div class="modal-header">
    <h4 class="modal-title">{{ 'liveSession.startConfirmTitle' | translate }}</h4>
    <button type="button" class="btn-close" (click)="cancel()"></button>
  </div>

  <div class="modal-body">
    <div class="schedule-info">
      <div class="info-icon">
        <i class="fa fa-play-circle"></i>
      </div>
      <h5 class="schedule-name">{{ schedule?.schedule_name }}</h5>
      @if (eventClass) {
        <p class="class-name">{{ eventClass.class_name }}</p>
      }
    </div>

    <div class="stats-grid">
      <div class="stat-item">
        <span class="stat-value">{{ participantCount }}</span>
        <span class="stat-label">{{ 'liveSession.participants' | translate }}</span>
      </div>
      <div class="stat-item">
        <span class="stat-value">{{ timePerEntry }}</span>
        <span class="stat-label">{{ 'liveSession.perEntry' | translate }}</span>
      </div>
      <div class="stat-item">
        <span class="stat-value">{{ estimatedDuration }}</span>
        <span class="stat-label">{{ 'liveSession.estimated' | translate }}</span>
      </div>
    </div>

    <div class="info-message">
      <i class="fa fa-info-circle"></i>
      <p>{{ 'liveSession.startConfirmMessage' | translate }}</p>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-outline" (click)="cancel()">
      {{ 'common.cancel' | translate }}
    </button>
    <button type="button" class="btn btn-success" (click)="confirm()">
      <i class="fa fa-play"></i>
      {{ 'liveSession.goLive' | translate }}
    </button>
  </div>
</div>
